console.log(SERVER, '---SERVER');
window.AppConf = require(`../config/servers/${SERVER}.config.js`).AppConf;
window.StaticHost = require(`../config/servers/${SERVER}.config.js`).staticHost;
